import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Select from "common/components/Select/Select";

export type ProcessOptionsType = (options: any[]) => {
  value: string;
  label: string;
}[];

function HistoryEventTypeSelect(props: any) {
  const { t } = useTranslation();

  // discuss if we want to see superadmin here
  const options = useMemo(
    () => [
      { value: "CREATE", label: t("history.requestTypeName.create") },
      { value: "UPDATE", label: t("history.requestTypeName.update") },
      { value: "DELETE", label: t("history.requestTypeName.delete") },
      { value: "ARCHIVE", label: t("history.requestTypeName.archive") },
      { value: "VALIDATE", label: t("history.requestTypeName.validate") },
      { value: "DENY", label: t("history.requestTypeName.deny") },
      { value: "ASK", label: t("history.requestTypeName.ask") },
      { value: "ANSWER", label: t("history.requestTypeName.answer") },
      { value: "IMPORT", label: t("history.requestTypeName.import") },
      { value: "EXPORT", label: t("history.requestTypeName.export") },
    ],
    [t]
  );

  return <Select options={options} {...props} />;
}

export default HistoryEventTypeSelect;
